"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOrderProtectedForCombo = void 0;
const constants_1 = require("@daytrip/constants");
const legacy_models_1 = require("@daytrip/legacy-models");
const utils_1 = require("@daytrip/utils");
function isOrderProtectedForCombo({ order, inClaimingTool }) {
    const isInItaly = order.pricingCountryId === constants_1.ITALY_COUNTRY_ID;
    const unlockOrderDaysUntilDepartureBase = isInItaly ? 35 : 28;
    const claimingToolAssignationPrecedenceDays = inClaimingTool ? 1 : 0;
    // Make the order available in the claiming tool 24hours before support starts assigning it
    const unlockOrderDaysUntilDeparture = unlockOrderDaysUntilDepartureBase + claimingToolAssignationPrecedenceDays;
    if ((0, utils_1.getTimeDiffInDays)(order.departureAt) <= unlockOrderDaysUntilDeparture) {
        return false;
    }
    // Multi-vehicle orders are not supported by the combo engine
    if (order.vehicles.length > 1 || order.isVIP || (0, legacy_models_1.isAirportTransfer)(order) || !order.travelEstimates) {
        return false;
    }
    // If the trip is long, it is likely to form a multi-day combo
    if (order.travelEstimates.distanceKm > 300) {
        return true;
    }
    const departureAt = new Date(order.departureAt);
    const startHour = departureAt.getUTCHours() + departureAt.getMinutes() / 60;
    const travelHours = order.travelEstimates.travelTimeMinutes / 60;
    const arrivalAtHour = startHour + travelHours;
    const arrivalAtConverted = arrivalAtHour % 24;
    // Prediction is based on most orders starting in the morning hours (8-12)
    // If order happens between 5 and 9 it's likely to form combo with morning orders
    if (arrivalAtConverted <= 9 && startHour >= 5 && startHour <= 9) {
        return true;
    }
    // 24 + part is to avoid getting negative values, examples:
    // 24 + 2 - 2 - 3 = 21 - remainder 21
    // 24 + 15 - 2 - 3 = 34 - remainder 10
    // 24 + 17 - 2 - 3 = 36 - remainder 12
    const oppositeDirectionTripIdealStartHour = (24 + startHour - 2 - travelHours) % 24;
    // If order is in the afternoon and the opposite direction trip would be starting in the morning
    if (oppositeDirectionTripIdealStartHour >= 9 && oppositeDirectionTripIdealStartHour <= 17) {
        return true;
    }
    return false;
}
exports.isOrderProtectedForCombo = isOrderProtectedForCombo;
//# sourceMappingURL=isOrderProtectedForCombo.js.map